module.exports = __webpack_public_path__ + "img/McD_FutureConcepts_Content_images_01.48be8e8a.jpg";